module.exports = __webpack_public_path__ + "static/media/warning-yellow.c74ce4fa.svg";